import { ComponentType, useCallback, useState } from 'react';
import { makeRequest } from '../service/makeRequest';
import { ExistingUser } from '../types/ExistingUser';
import { NewUser } from '../types/NewUser';

const DEFAULT_NEW_USER: NewUser = {
  username: '',
  password: '',
  super: false,
};

type Props = {
  onUserAdded: (newUser: ExistingUser) => void;
};

export const NewUserRow: ComponentType<Props> = ({ onUserAdded }) => {
  const [newUser, setNewUser] = useState<NewUser>(DEFAULT_NEW_USER);
  const [isLoading, setLoading] = useState(false);

  const updateNewUser: <T extends keyof NewUser>(
    property: T,
    value: NewUser[T]
  ) => void = useCallback(
    (property, value) =>
      setNewUser((newUser) => ({ ...newUser, [property]: value })),
    []
  );

  return (
    <tr>
      <th></th>
      <td>
        <input
          disabled={isLoading}
          onChange={({ target: { value } }) => updateNewUser('username', value)}
          value={newUser.username}
        />
      </td>
      <td>
        <input
          disabled={isLoading}
          onChange={({ target: { value } }) => updateNewUser('password', value)}
          value={newUser.password}
        />
      </td>
      <td>
        <input
          checked={newUser.super}
          disabled={isLoading}
          type="checkbox"
          onChange={() => updateNewUser('super', !newUser.super)}
        />
      </td>
      <td>
        <button
          disabled={isLoading}
          onClick={() =>
            makeRequest(
              'POST',
              '/users',
              newUser,
              setLoading,
              onUserAdded,
              () => setNewUser(DEFAULT_NEW_USER)
            )
          }
        >
          Add
        </button>
      </td>
    </tr>
  );
};
